import { DateTimeFlexible } from './DateTimeFlexible';
import { DateTimeSerializableFromDateTimeFlexible } from './DateTimeFlexibleFromDateTimeSerializable';
import { Schema } from 'effect';

/**
 * Schema that transforms ISO string directly to SerializableDateTime.
 * Useful for API responses - validates and normalizes the datetime string.
 *
 * Decode: `"2024-12-10T14:30:00+01:00"` → `{ _tag: 'DateTime', value: '2024-12-10T14:30:00.000+01:00' }`
 * Encode: `{ _tag: 'DateTime', value: '...' }` → `"..."`
 */
// v4: `Schema.compose(from, to)` was removed; use `from.pipe(Schema.decodeTo(to))`
// for natural-passthrough composition (Transformation.passthrough() under the hood).
export const DateTimeSerializableFromString = DateTimeFlexible.pipe(
  Schema.decodeTo(DateTimeSerializableFromDateTimeFlexible)
);

export type DateTimeSerializableFromString = Schema.Schema.Type<
  typeof DateTimeSerializableFromString
>;
